import { render, staticRenderFns } from "./initilarolemenu.vue?vue&type=template&id=2c10831a&scoped=true&"
import script from "./initilarolemenu.vue?vue&type=script&lang=js&"
export * from "./initilarolemenu.vue?vue&type=script&lang=js&"
import style0 from "./initilarolemenu.vue?vue&type=style&index=0&id=2c10831a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10831a",
  null
  
)

export default component.exports